export const MUTATION_INCREMENT_COUNT = /* GraphQL */ `
	mutation ($key: String!) {
		incrementCount(key: $key) {
			countValue {
				total
				cid
			}
		}
	}
`;
